module.exports = __webpack_public_path__ + "img/income-profit-up.9cb967dc.svg";